import jsonLogic from 'json-logic-js'
jsonLogic.add_operation('toLowerCase', v => typeof v === 'string' ? v.toLowerCase() : v)

jsonLogic.add_operation('match', (value, pattern) => {
  if (typeof value !== 'string') return false
  return new RegExp(pattern).test(value)
})

export function createCanAccess(store) {
  return function(input) {
    let rule = input

    // 🔑 If string → resolve from store
    if (typeof input === 'string') {
      rule = store.state.ENTITLEMENTS?.[input]
    }

    if (!rule) {
      console.warn('Missing entitlement rule:', input)
      return false
    }

    // ⚠️ strip Vue reactivity
    const cleanRule = JSON.parse(JSON.stringify(rule))

    const context = new Proxy({}, {
      get: (_, key) => {
        if (key === 'getters') {
          return new Proxy({}, {
            get: (_, k) => store.getters.get(k)
          })
        }
        return store.state[key]
      }
    })
try {
      return !!jsonLogic.apply(cleanRule, context)
    } catch (e) {
      console.log('Invalid entitlement rule:', rule, e)
      return false
    }
  }
}
